import React from 'react';
import { Colors, ColorValues, Flex, IconCheck } from '@banhala/ui-kit';

const SIZE = 40;
const ICON_SIZE = 24;

export const OverlayCheckBoxView: React.FC<{ checked: boolean }> = props => {
  return (
    <Flex.Center
      position={'absolute'}
      top={0}
      right={0}
      width={SIZE}
      height={SIZE}
    >
      <Flex.Center
        width={ICON_SIZE}
        height={ICON_SIZE}
        borderRadius={ICON_SIZE * 0.5}
        borderWidth={2}
        borderColor={'white'}
        backgroundColor={props.checked ? 'bg_blue_primary' : undefined}
        backgroundColorValue={
          props.checked ? undefined : ColorValues.alpha_dark10
        }
      >
        {props.checked && (
          <IconCheck size={16} fill={Colors.content_always_white} />
        )}
      </Flex.Center>
    </Flex.Center>
  );
};
